import Input from '../../common/Input';

export default function Step1_ContactInfo({ register, errors }) {
  return (
    <section>
      <h2>1. Lični podaci</h2>
      <Input label="Ime" {...register('name', { required: 'Obavezno' })} error={errors.name?.message} />
      <Input label="Email" type="email" {...register('email', { required: 'Obavezno' })} error={errors.email?.message} />
      <Input label="Telefon" type="tel" {...register('phone', { required: 'Obavezno' })} error={errors.phone?.message} />
    </section>
  );
}
